module.exports = __webpack_public_path__ + "img/logo-softbusiness.822283a3.png";